



















































import Vue from 'vue'
export default Vue.extend({
  props: {
    categoryName: {
      type: String,
      required: true
    },
    // NOTE: Null is received when date is not defined on serverside.
    // Hence it is not possible to have required parameter.
    fullColorShippingDate: {
      type: String,
      default: null
    },
    singleColorShippingDate: {
      type: String,
      default: null
    }
  },
  methods: {
    displayDate(date: string) {
      return date ?? '-'
    }
  }
})
